export default __webpack_public_path__ + "static/2-e10d5c32350858ec1f96c28f0b75e120.jpeg";